export const SWIDGET_MODAL_CLASS_NAME = 'swidget-modal-container'
export const SWIDGET_MODAL_ID_PREFIX = 'swidget-modal-container-'

export const SWIDGET_MODAL_STYLE_ID_PREFIX = 'swidget-modal-style-'

export const SWIDGET_MODAL_TARGET_CLASS_NAME = 'swidget-modal-target'
export const SWIDGET_MODAL_TARGET_ID_PREFIX = 'swidget-modal-target-'

export const SWIDGET_MODAL_IMAGE_BACKGROUND_CLASS_NAME = 'swidget-modal-image-background'

export const SWIDGET_MODAL_BACKGROUND_TRANSITION = '1.5s'

export const MODAL_DEFAULT_Z_INDEX = 1010
export const MODAL_DEFAULT_PROPS = { active: true, zIndex: MODAL_DEFAULT_Z_INDEX }
